'use client';

import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';

export default function HotelSearchForm() {
  const router = useRouter();
  const [destination, setDestination] = useState('');
  const [checkIn, setCheckIn] = useState('');
  const [checkOut, setCheckOut] = useState('');
  const [rooms, setRooms] = useState(1);
  const [guests, setGuests] = useState(2);
  const [showGuestPicker, setShowGuestPicker] = useState(false);

  const handleSearch = () => {
    // BACKEND: POST /api/search/hotels with { destination, checkIn, checkOut, rooms, guests }
    router?.push('/search-results-page');
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        {/* Destination */}
        <div className="lg:col-span-2">
          <label className="block text-xs font-600 text-muted-foreground mb-1">Destination</label>
          <div className="relative">
            <Icon name="MapPinIcon" size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-accent pointer-events-none" />
            <input
              type="text"
              value={destination}
              onChange={(e) => setDestination(e?.target?.value)}
              placeholder="City, region, or hotel name"
              className="input-base w-full pl-9 pr-3 py-3 text-sm"
            />
          </div>
        </div>

        {/* Check-in / Check-out */}
        <div>
          <label className="block text-xs font-600 text-muted-foreground mb-1">Check-in</label>
          <input
            type="date"
            value={checkIn}
            onChange={(e) => setCheckIn(e?.target?.value)}
            className="input-base w-full px-3 py-3 text-sm"
          />
        </div>
        <div>
          <label className="block text-xs font-600 text-muted-foreground mb-1">Check-out</label>
          <input
            type="date"
            value={checkOut}
            onChange={(e) => setCheckOut(e?.target?.value)}
            className="input-base w-full px-3 py-3 text-sm"
          />
        </div>
      </div>
      <div className="flex items-center justify-between">
        {/* Rooms & Guests */}
        <div className="relative">
          <button
            type="button"
            onClick={() => setShowGuestPicker(!showGuestPicker)}
            className="input-base px-4 py-2.5 text-sm flex items-center gap-2"
          >
            <Icon name="UserGroupIcon" size={16} className="text-muted-foreground" />
            <span>{rooms} Room{rooms > 1 ? 's' : ''}, {guests} Guest{guests > 1 ? 's' : ''}</span>
            <Icon name="ChevronDownIcon" size={14} className="text-muted-foreground" />
          </button>

          {showGuestPicker && (
            <div className="absolute top-full left-0 mt-1 bg-card border border-border rounded-xl shadow-card-lg z-20 p-4 space-y-3 min-w-[220px]">
              {[
                { label: 'Rooms', value: rooms, setter: setRooms, min: 1 },
                { label: 'Guests', value: guests, setter: setGuests, min: 1 },
              ]?.map(({ label, value, setter, min }) => (
                <div key={`hotel-guest-${label}`} className="flex items-center justify-between">
                  <span className="text-sm font-semibold">{label}</span>
                  <div className="flex items-center gap-3">
                    <button
                      type="button"
                      onClick={() => setter(Math.max(min, value - 1))}
                      className="w-7 h-7 rounded-full border border-border flex items-center justify-center hover:bg-muted transition-colors disabled:opacity-40"
                      disabled={value <= min}
                    >
                      <Icon name="MinusIcon" size={14} />
                    </button>
                    <span className="text-sm font-semibold w-4 text-center tabular-nums">{value}</span>
                    <button
                      type="button"
                      onClick={() => setter(value + 1)}
                      className="w-7 h-7 rounded-full border border-border flex items-center justify-center hover:bg-muted transition-colors"
                    >
                      <Icon name="PlusIcon" size={14} />
                    </button>
                  </div>
                </div>
              ))}
              <button
                type="button"
                onClick={() => setShowGuestPicker(false)}
                className="btn-primary w-full py-2 text-sm"
              >
                Done
              </button>
            </div>
          )}
        </div>

        <button
          type="button"
          onClick={handleSearch}
          className="btn-primary px-8 py-3 text-sm flex items-center gap-2"
        >
          <Icon name="MagnifyingGlassIcon" size={18} />
          Search Hotels
        </button>
      </div>
    </div>
  );
}